import { useEffect, useState, useCallback } from 'react';
import { Card, Table, Tag, Button, Space, message, Popconfirm } from 'antd';
import dayjs from 'dayjs';
import { getSoftwareUpdateListAPI, setVersionUnusedAPI } from '@/apis/softwareUpdate';

const sourceColor = (s)=>{
  switch(s){
    case 'design': return 'geekblue';
    case 'execute': return 'green';
    case 'point': return 'purple';
    default: return 'default';
  }
};

const SoftwareUpdateList = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchList = useCallback(async ()=>{
    setLoading(true);
    try {
      const res = await getSoftwareUpdateListAPI();
      if(res.code===0 && Array.isArray(res.data)) setData(res.data);
      else message.error(res.msg || '获取列表失败');
    } catch(e){
      console.error(e);
      message.error('获取列表失败');
    } finally { setLoading(false); }
  },[]);

  useEffect(()=>{ fetchList(); }, [fetchList]);

  const disableVersion = async (record)=>{
    try {
      await setVersionUnusedAPI(record.id);
      message.success('已设为不可用');
      fetchList();
    } catch(e){ message.error('操作失败'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '应用', dataIndex: 'appSource', render: v=> <Tag color={sourceColor(v)}>{v}</Tag> },
    { title: '版本号', dataIndex: 'version' },
    { title: '状态', dataIndex: 'canUse', render: v=> v? <Tag color="green">可用</Tag>:<Tag color="red">不可用</Tag> },
    { title: '下载地址', dataIndex: 'downloadUrl', render: v=> v? <a href={v} target="_blank" rel="noreferrer">打开</a>:'-' },
    { title: '创建时间', dataIndex: 'createdAt', render: v=> v? dayjs(v).format('YYYY-MM-DD HH:mm:ss'):'-' },
    { title: '更新时间', dataIndex: 'updatedAt', render: v=> v? dayjs(v).format('YYYY-MM-DD HH:mm:ss'):'-' },
    { title: '操作', key: 'action', render: (_, record)=> (
        <Space>
          {record.canUse===1 && (
            <Popconfirm title='确认设为不可用?' onConfirm={()=>disableVersion(record)}>
              <Button danger size='small'>设为不可用</Button>
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <Card title="软件更新列表" extra={<Button onClick={fetchList} loading={loading}>刷新</Button>}>
      <Table rowKey='id' loading={loading} dataSource={data} columns={columns} pagination={false} />
    </Card>
  );
};

export default SoftwareUpdateList;
